<div class="nav-container" [ngClass]="{'scrolled': isScrolled, 'menu-open': isMenuOpen}">
  <div class="nav-left">
    <a [routerLink]="getRouterLink('')" class="logo-link">
      <img width="200" src="https://applisound-images.s3.eu-west-3.amazonaws.com/applisound-bleu.png"
        alt="Applisound logo"
        [ngClass]="{'mobile-logo': isMobile}">
    </a>

    @if (isMobile) {
      <button class="burger-menu" (click)="toggleMenu()" aria-label="Toggle menu">
        <span [class.active]="isMenuOpen"></span>
        <span [class.active]="isMenuOpen"></span>
        <span [class.active]="isMenuOpen"></span>
      </button>
    }
  </div>

  <nav class="nav-links" [class.mobile-menu]="isMobile" [class.show]="isMenuOpen" #linksContainer>
    <div class="nav-indicator" [style.transform]="'translateX(' + indicatorPosition + 'px)'" [style.width]="indicatorWidth + 'px'" [style.opacity]="hasActiveLink ? 1 : 0"></div>

    <a [routerLink]="getRouterLink('music')" routerLinkActive="active" (click)="closeMenuIfMobile()" #navLink>
      {{ 'NAV.MUSIC' | translate }}
    </a>
    <a [routerLink]="getRouterLink('soundsvideo')" routerLinkActive="active" (click)="closeMenuIfMobile()" #navLink>
      {{ 'NAV.SOUNDSVIDEO' | translate }}
    </a>
    <a [routerLink]="getRouterLink('boutique')" routerLinkActive="active" (click)="closeMenuIfMobile()" #navLink>
      {{ 'NAV.SHOP' | translate }}
    </a>
    <a [routerLink]="getRouterLink('')" fragment="services" (click)="closeMenuIfMobile()" #navLink>
      {{ 'NAV.SERVICES' | translate }}
    </a>
    <a [routerLink]="getRouterLink('')" fragment="pricing" (click)="closeMenuIfMobile()" #navLink>
      {{ 'NAV.PRICING' | translate }}
    </a>
    <a [routerLink]="getRouterLink('')" fragment="process" (click)="closeMenuIfMobile()" #navLink>
      {{ 'NAV.HOW_IT_WORKS' | translate }}
    </a>


    @if (isMobile) {
      <div class="mobile-auth">
        @if (isLoggedIn && userDisplayName) {
          <div class="user-row">
            <i class="fas fa-user-circle"></i>
            <span class="user-name">{{ userDisplayName }}</span>
          </div>
          <div class="mobile-actions">
            <button class="icon-btn" (click)="goToDashboard(); closeMenuIfMobile()" aria-label="Dashboard"><i class="fas fa-th-large"></i></button>
            <button class="icon-btn" (click)="onLogout()" aria-label="Logout"><i class="fas fa-sign-out-alt"></i></button>
          </div>
        } @else {
          <button class="btn-login" [routerLink]="getRouterLink('login')" (click)="closeMenuIfMobile()">
            {{ 'NAV.LOGIN' | translate }}
          </button>
          <button class="btn-create-account" [routerLink]="getRouterLink('signup')" (click)="closeMenuIfMobile()">
            {{ 'NAV.CREATE_ACCOUNT' | translate }}
          </button>
        }
      </div>
    }
  </nav>

  @if (!isMobile) {
    <div class="nav-right">
      @if (isLoggedIn && userDisplayName) {
        <div class="user-chip" title="{{ userDisplayName }}">
          <i class="fas fa-user-circle"></i>
          <span class="user-name">{{ userDisplayName }}</span>
        </div>
        <button class="icon-btn" aria-label="Dashboard" (click)="goToDashboard()" title="Dashboard">
          <i class="fas fa-th-large"></i>
        </button>
        <button class="icon-btn" aria-label="Logout" (click)="onLogout()" title="Logout">
          <i class="fas fa-sign-out-alt"></i>
        </button>
      } @else {
        <button class="btn-login" [routerLink]="getRouterLink('login')">{{ 'NAV.LOGIN' | translate }}</button>
        <button class="btn-create-account" [routerLink]="getRouterLink('signup')">{{ 'NAV.CREATE_ACCOUNT' | translate }}</button>
      }
    </div>
  }
</div>